export function parseCollapsedBelow(collapsedBelow) {
  return [collapsedBelow === 'tablet' || collapsedBelow === 'desktop', collapsedBelow === 'desktop', false];
}